import { Card, Heading } from '@dittolive/anvil'
import React from 'react'

type Props = {
  title: string
  description: string
  children: React.ReactNode
  disableBodyPadding?: boolean
}
export default function DataBridgeSectionCard({
  title,
  description,
  children,
  disableBodyPadding = true,
}: Props) {
  return (
    <Card className="w-full">
      <Card.Header className="w-full px-4 pb-6 pt-4" isFlushed>
        <Heading level={3}>{title}</Heading>
        <p className="text-foreground-subtle text-base leading-5">
          {description}
        </p>
      </Card.Header>
      <Card.Body className="w-full" isFlushed={disableBodyPadding}>
        {children}
      </Card.Body>
    </Card>
  )
}
